import { render, staticRenderFns } from "./facturaDeVenta.vue?vue&type=template&id=2785c6de"
import script from "./facturaDeVenta.vue?vue&type=script&lang=js"
export * from "./facturaDeVenta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports